import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useContext, useState } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import { useDeleteAppRequest } from "src/services/organizations/commands/app";
import { getOrgAppsRequest } from "src/services/organizations/queries/apps";
import { AppType } from "src/types/apps";
import { PATH_DASHBOARD } from "src/utils/paths";
import SnackbarUtils from "src/utils/SnackbarUtils";

import DialogContext from "../context";

type Props = {
	onIncorrectPassword: () => void;
};

export default function useDeleteApp({ onIncorrectPassword }: Props) {
	const [isLoading, setIsLoading] = useState(false);
	const { onClose } = useContext(DialogContext);

	const { mutate } = useDeleteAppRequest();

	const org = useGetOrg();
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	const appId = queryClient.getQueryData<string>(["apps", "selected"]) ?? "";
	const apps = (queryClient.getQueryData<AppType[]>(["apps"]) ?? []).filter((i) => i.id !== appId);

	const onDeleteApp = (password: string) => {
		setIsLoading(true);
		mutate(
			{ orgId: org.id, appId, password },
			{
				onSuccess: () => {
					setIsLoading(false);

					getOrgAppsRequest(org.id).then((newApps: AppType[]) =>
						queryClient.setQueryData(["apps"], () => [...newApps])
					);

					if (apps.length > 0) {
						queryClient.setQueryData(["apps", "selected"], () => apps[0].id);
					}

					SnackbarUtils.success("Se ha eliminado tu aplicación con éxito.");
					onClose();

					navigate({ to: PATH_DASHBOARD.app.overview });
				},
				onError: ({ response }: any) => {
					setIsLoading(false);
					if (response?.data?.message === "incorrect_password") {
						onIncorrectPassword();
					} else {
						SnackbarUtils.error("Se ha producido un error al intentar eliminar tu aplicación.");
					}
				}
			}
		);
	};

	return { onDeleteApp, isLoading };
}
